import { createContext, useContext } from 'react'
import type { AccountPageUIProps } from './types'

export const AccountPageUIContext = createContext<AccountPageUIProps | null>(null)

interface AccountPageUIProviderProps extends AccountPageUIProps {
  children: React.ReactNode
}

export const AccountPageUIProvider = ({ children, ...props }: AccountPageUIProviderProps) => {
  return (
    <AccountPageUIContext.Provider value={props}>
      {children}
    </AccountPageUIContext.Provider>
  )
}

export const useAccountPageUIContext = () => {
  const ctx = useContext(AccountPageUIContext)
  if (!ctx) {
    throw new Error('useAccountPageUIContext must be used within an AccountPageUIProvider')
  }
  return ctx
}
